import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getWorkOrdersCount = {
  name: "getWorkOrdersCount" as const,
  input: z.object({
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    stationId: z.string().regex(/^\d+$/).nullish(),
  }),
  output: z.object({ total: z.number() }),
};
